<div [formGroup]="parentForm">
  <div [formGroupName]="authControlKey">
    <div fxLayout="row wrap" fxLayoutGap="20px grid">
      <div fxFlex="100">
        <mat-card class="u-margin-bottom-15">
          <mat-card-header>
            <mat-card-title
              >{{
              "organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.authentication_details"
              | translate }}</mat-card-title
            >
          </mat-card-header>
          <mat-card-content>
            <div fxLayout="row wrap" fxLayoutGap="20px grid">
              <div fxFlex="50">
                <mat-form-field class="mat-block">
                  <input
                    [required]="isRequired('ebasketInventoryAptosAuthorisation')"
                    formControlName="ebasketInventoryAptosAuthorisation"
                    id="ebasketInventoryAptosAuthorisation"
                    matInput
                    [placeholder]="
                    'magento.ebasket_setion.inventory.account_id' |
                    translate"
                  />
                </mat-form-field>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
    <div fxLayout="row wrap" fxLayoutGap="20px grid">
      <div fxFlex="100">
        <mat-card class="u-margin-bottom-15">
          <mat-card-header>
            <div fxFlex="20" class="u-text-left">
              <mat-card-title>{{ "crestengagement.queueDetails" | translate }}</mat-card-title>
            </div>
            <div fxFlex="80" class="u-text-right">
              <button
                [disabled]="action=='view' || isEBasketInventoryAddDisabled"
                mat-flat-button
                color="primary"
                (click)="openEbasketInventorySelectApiPopup();"
              >
                {{ 'magento.add' | translate}}
              </button>
            </div>
          </mat-card-header>
          <mat-card-content *ngIf="showQueueDetails">
            <mat-card-header>
              <div fxFlex="20" class="u-text-left">
                <mat-card-title
                  >{{ "crestengagement.salesExportQueue" | translate }}</mat-card-title
                >
              </div>
            </mat-card-header>

            <mat-form-field class="mat-block">
              <input
                [required]="isRequired('ebasketSalesExportRoleName')"
                formControlName="ebasketSalesExportRoleName"
                id="ebasketSalesExportRoleName"
                matInput
                [placeholder]="
                'crestengagement.roleName' |
                translate"
              />
            </mat-form-field>
            <mat-form-field class="mat-block">
              <input
                [required]="isRequired('ebasketSalesExportQueueName')"
                formControlName="ebasketSalesExportQueueName"
                id="ebasketSalesExportQueueName"
                matInput
                [placeholder]="
                'crestengagement.queueName' |
                translate"
              />
            </mat-form-field>
            <mat-form-field class="mat-block">
              <input
                [required]="isRequired('ebasketSalesExportExternalId')"
                formControlName="ebasketSalesExportExternalId"
                id="ebasketSalesExportExternalId"
                matInput
                [placeholder]="
                  'crestengagement.ExternalId' |
                  translate"
              />
            </mat-form-field>
            <mat-card-header>
              <!-- <div fxFlex="90" class="u-text-right">
                  <button
                    [disabled]="action=='view' || isEBasketSalesExportAddQueuDetailsDisabled"
                    mat-flat-button
                    color="primary"
                    (click)="addeBasketSalesExportQueueDetails();"
                  >
                    {{ 'organization.module_assignment_tab.crestengagement.addBtn' |
                    translate}}
                  </button>
                </div> -->
              <div fxFlex="10" class="u-text-right">
                <button
                  [disabled]="action=='view'"
                  mat-flat-button
                  color="primary"
                  (click)="deleteeBasketSalesExportQueueDetails();"
                >
                  {{ 'crestengagement.deleteBtn' | translate}}
                </button>
              </div>
            </mat-card-header>
          </mat-card-content>
          <!-- <mat-error
            *ngIf="frmModuleAssignment.controls['ebasketSalesExportRoleName'].errors || frmModuleAssignment.controls['ebasketSalesExportQueueName'].errors || frmModuleAssignment.controls['ebasketSalesExportExternalId'].errors"
          >
            {{ "organization.create.section_4.queueDetails_required" | translate }}
          </mat-error> -->
          <!-- <div
            *ngFor="let apiDetails of parentForm.get(authControlKey).get('ebasketInventoryApiDetails')['controls']; let i = index"
          >
            <mat-error *ngIf="!apiDetails.value.url || !apiDetails.value.method">
              {{
              "organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.api_and_authentication_details_required"
              | translate }}
            </mat-error>
          </div> -->
        </mat-card>
      </div>
    </div>
  </div>
</div>
